import React from 'react'
import type { FieldProps } from 'formik'
import type { InputFieldProps } from '../components/InputField'
import InputField from '../components/InputField'

export interface FormikInputFieldProps extends FieldProps<any>, Omit<InputFieldProps, 'form' | 'classes'> {
  valueDefault?: any
}

/**
 * Helper component to use with a Formik <Field />
 */
const FormikInputField = ({ field, valueDefault, ...props }: FormikInputFieldProps) => {
  return <InputField {...field} {...props} value={field.value ?? valueDefault} />
}

export default FormikInputField
